import type { SupportedLocale } from "@frontend/types";

export const DATE_PICKER_TAG_NAME = "date-picker" as const;

export const DATE_PICKER_LAYOUTS = ["default", "text", "icon"] as const;

export const WEEK_START: Record<SupportedLocale, 0 | 1> = {
  en: 0,
  fr: 1,
};

export const ARROW_SIZES: Record<"sm" | "md" | "lg", number> = {
  sm: 6,
  md: 8,
  lg: 10,
};
